<template>
    <div class="content-wrapper">
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark">Complains</h1>
                    </div>
                    <div class="col-sm-6">
                        <button class="btn btn-info float-right" @click="showCreateModal"><i class="fas fa-plus-circle"></i> Create</button>
                    </div>
                </div>
            </div>
        </div>
        <section class="content">
            <div class="container-fluid">
                <div class="row mb-3">
                    <div class="col-md-2 mb-2">
                        <input type="text" class="form-control" v-model="filter.code" placeholder="Complain ID" @keyup.enter="searchData">
                    </div>
                    <div class="col-md-2 mb-2">
                        <input type="text" class="form-control" v-model="filter.order_id" placeholder="Order ID" @keyup.enter="searchData">
                    </div>
                    <div class="col-md-2 mb-2">
                        <v-select name="merchant_id"
                            v-model="filter.merchant_id"
                            label="text"
                            :reduce="item => item.id"
                            :options="commonObj.merchantList"
                            placeholder="Merchant"
                        />
                    </div>
                    <div class="col-md-2 mb-2">
                        <v-select name="assigned_user_id"
                            v-model="filter.assigned_user_id"
                            label="text"
                            :reduce="item => item.id"
                            :options="commonObj.userList"
                            placeholder="Assigned To"
                        />
                    </div>
                    <div class="col-md-2 mb-2">
                        <v-select name="status"
                            v-model="filter.status"
                            label="text"
                            :reduce="item => item.id"
                            :options="statusOptions"
                            placeholder="Status"
                        />
                    </div>
                    <div class="col-md-2 mb-2">
                        <button class="btn btn-info btn-sm" @click="searchData" title="Search"><i class="fas fa-search"></i></button>
                        <button class="btn btn-warning btn-sm ml-1" @click.prevent="reload"><i class="fa fa-sync-alt"></i></button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <b-overlay :show="loader">
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-striped table-sm">
                                            <thead>
                                                <tr>
                                                    <th>SL</th>
                                                    <th>Complain ID</th>
                                                    <th>Parcel</th>
                                                    <th>Title</th>
                                                    <th>Raised By</th>
                                                    <th>Assigned Role</th>
                                                    <th>Assigned To</th>
                                                    <th>Status</th>
                                                    <th style="text-align:center;">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(complain, index) in listData" :key="complain.id">
                                                    <td>{{ index + pagination.slOffset }}</td>
                                                    <td>{{ complain.code }}<copy-id :id="complain.code" /></td>
                                                    <td>{{ complain.order ? complain.order.id : '-' }}<copy-id v-if="complain.order" :id="complain.order.id" /></td>
                                                    <td>
                                                        {{ complain.title }}
                                                        <a v-if="complain.image" :href="imagePath + complain.image" target="_blank" title="View attachment"><i class="fas fa-paperclip"></i></a>
                                                    </td>
                                                    <td>{{ raisedByLabel(complain) }}</td>
                                                    <td>{{ complain.assigned_role ? complain.assigned_role.name : '' }}</td>
                                                    <td>{{ complain.assigned_user ? complain.assigned_user.name : '' }}</td>
                                                    <td>
                                                        <span :class="'badge complain-status-' + complain.status">{{ statusLabel(complain.status) }}</span>
                                                    </td>
                                                    <td style="text-align:center; white-space: nowrap;">
                                                        <button class="btn btn-warning btn-sm mr-1" v-if="complain.status !== 5" title="Assign" @click="openAssignModal(complain)"><i class="fas fa-user-tag"></i></button>
                                                        <button class="btn btn-primary btn-sm mr-1" title="Reply" @click="openReplyModal(complain)"><i class="fas fa-reply"></i></button>
                                                        <button class="btn btn-secondary btn-sm mr-1" title="History" @click="openHistoryModal(complain)"><i class="fas fa-history"></i></button>
                                                        <v-select
                                                            v-if="complain.status !== 5"
                                                            class="d-inline-block align-middle"
                                                            style="width: 140px;"
                                                            name="status"
                                                            :value="statusOptions.find(o => o.id == complain.status)"
                                                            label="text"
                                                            :reduce="item => item.id"
                                                            :options="statusOptions"
                                                            :clearable="false"
                                                            append-to-body
                                                            :calculate-position="dropdownPosition"
                                                            @input="(val) => updateStatus(complain, val)"
                                                        />
                                                    </td>
                                                </tr>
                                                <tr v-if="listData.length == 0">
                                                    <td colspan="9" class="text-center">No complains found</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="mt-3">
                                        <b-pagination
                                            v-model="pagination.currentPage"
                                            :per-page="pagination.perPage"
                                            :total-rows="pagination.totalRows"
                                            @input="searchData"
                                        />
                                    </div>
                                </b-overlay>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Create modal -->
        <div v-if="createModal" class="modal fade show" style="display:block" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <b-overlay :show="loader">
                        <div class="modal-header bg-info text-white">
                            <h5 class="modal-title text-center w-100">Create Complain</h5>
                            <button type="button" class="close" aria-label="Close" @click="cancelModal">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <label for="title">Title <span class="text-danger">*</span></label>
                                <input type="text" id="title" v-model="form.title" class="form-control" placeholder="Title">
                                <span class="text-danger" v-if="errors.title">{{ errors.title[0] }}</span>
                            </div>
                            <div class="form-group">
                                <label for="description">Description <span class="text-danger">*</span></label>
                                <textarea id="description" v-model="form.description" class="form-control" rows="4" placeholder="Description"></textarea>
                                <span class="text-danger" v-if="errors.description">{{ errors.description[0] }}</span>
                            </div>
                            <div class="form-group">
                                <label for="order_id">Parcel / Order ID (optional)</label>
                                <input type="text" id="order_id" v-model="form.order_id" class="form-control" placeholder="Bahok ID">
                                <span class="text-danger" v-if="errors.order_id">{{ errors.order_id[0] }}</span>
                            </div>
                            <div class="form-group">
                                <label for="image">Attachment (optional)</label>
                                <input type="file" id="image" ref="imageInput" class="form-control" accept="image/*" @change="onFileChange">
                            </div>
                            <div class="form-group">
                                <label>Assign to Department (Role) <span class="text-danger">*</span></label>
                                <v-select name="assigned_role_id"
                                    v-model="form.assigned_role_id"
                                    label="text"
                                    :reduce="item => item.id"
                                    :options="roleList"
                                    placeholder="Select role"
                                    @input="form.assigned_user_id = null"
                                />
                                <span class="text-danger" v-if="errors.assigned_role_id">{{ errors.assigned_role_id[0] }}</span>
                            </div>
                            <div class="form-group" v-if="form.assigned_role_id">
                                <label>Assign to Person (optional)</label>
                                <v-select name="assigned_user_id"
                                    v-model="form.assigned_user_id"
                                    label="text"
                                    :reduce="item => item.id"
                                    :options="roleWiseUserList(form.assigned_role_id)"
                                    placeholder="Select person"
                                />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-info" @click.prevent="createComplain">Save</button>
                            <button type="button" class="btn btn-danger" @click="cancelModal">Cancel</button>
                        </div>
                    </b-overlay>
                </div>
            </div>
        </div>

        <!-- Assign modal -->
        <div v-if="assignModal" class="modal fade show" style="display:block" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <b-overlay :show="loader">
                        <div class="modal-header bg-warning text-white">
                            <h5 class="modal-title text-center w-100">Assign Complain</h5>
                            <button type="button" class="close" aria-label="Close" @click="cancelModal">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" v-if="assignForm">
                            <p><strong>{{ assignForm.title }}</strong></p>
                            <div class="form-group">
                                <label>Department (Role) <span class="text-danger">*</span></label>
                                <v-select name="assigned_role_id"
                                    v-model="assignForm.assigned_role_id"
                                    label="text"
                                    :reduce="item => item.id"
                                    :options="roleList"
                                    placeholder="Select role"
                                    @input="assignForm.assigned_user_id = null"
                                />
                                <span class="text-danger" v-if="errors.assigned_role_id">{{ errors.assigned_role_id[0] }}</span>
                            </div>
                            <div class="form-group" v-if="assignForm.assigned_role_id">
                                <label>Person (optional)</label>
                                <v-select name="assigned_user_id"
                                    v-model="assignForm.assigned_user_id"
                                    label="text"
                                    :reduce="item => item.id"
                                    :options="roleWiseUserList(assignForm.assigned_role_id)"
                                    placeholder="Select person"
                                />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-info" @click.prevent="submitAssign">Assign</button>
                            <button type="button" class="btn btn-danger" @click="cancelModal">Cancel</button>
                        </div>
                    </b-overlay>
                </div>
            </div>
        </div>

        <!-- History modal -->
        <div v-if="historyModal" class="modal fade show" style="display:block" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <b-overlay :show="historyLoader">
                        <div class="modal-header bg-secondary text-white">
                            <h5 class="modal-title text-center w-100">Assignment History{{ historyComplain ? ' - ' + historyComplain.code : '' }}</h5>
                            <button type="button" class="close" aria-label="Close" @click="cancelModal">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <ul class="list-group" v-if="historyList.length > 0">
                                <li class="list-group-item" v-for="item in historyList" :key="item.id">
                                    <div>
                                        <strong>Role:</strong> {{ item.assigned_role ? item.assigned_role.name : '-' }}
                                        &nbsp;<strong>Person:</strong> {{ item.assigned_user ? item.assigned_user.name : '-' }}
                                    </div>
                                    <div class="text-muted small">
                                        By {{ item.assigned_by_user ? item.assigned_by_user.name : 'System (auto-routed)' }} on {{ item.created_at | dateformat }} at {{ item.created_at | timeformat }}
                                    </div>
                                </li>
                            </ul>
                            <p v-else class="text-center text-muted">No assignment history yet</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" @click="cancelModal">Close</button>
                        </div>
                    </b-overlay>
                </div>
            </div>
        </div>

        <!-- Reply modal -->
        <div v-if="replyModal" class="modal fade show" style="display:block" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <b-overlay :show="replyLoader">
                        <div class="modal-header bg-primary text-white">
                            <h5 class="modal-title text-center w-100">Reply{{ replyComplain ? ' - ' + replyComplain.code : '' }}</h5>
                            <button type="button" class="close" aria-label="Close" @click="cancelModal">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="reply-thread mb-3" v-if="replyList.length > 0">
                                <div class="reply-item" v-for="item in replyList" :key="item.id">
                                    <div>
                                        <strong>{{ item.replied_by_merchant ? item.replied_by_merchant.business : (item.replied_by_user ? item.replied_by_user.name : 'System') }}</strong>
                                        <span v-if="item.status_at_reply" class="badge badge-light ml-1">
                                            set status to {{ statusLabel(Number(item.status_at_reply)) }}
                                        </span>
                                        <span class="text-muted small float-right">{{ item.created_at | dateformat }} at {{ item.created_at | timeformat }}</span>
                                    </div>
                                    <p class="mb-2" style="white-space: pre-wrap;">{{ item.body }}</p>
                                </div>
                            </div>
                            <p v-else class="text-center text-muted">No replies yet</p>

                            <div v-if="replyComplain && replyComplain.status !== 5">
                                <div class="form-group">
                                    <label for="reply_body">Reply <span class="text-danger">*</span></label>
                                    <textarea id="reply_body" v-model="replyForm.body" class="form-control" rows="4" placeholder="Write a reply..."></textarea>
                                    <span class="text-danger" v-if="errors.body">{{ errors.body[0] }}</span>
                                </div>
                                <div class="form-group">
                                    <label>Set Status (optional)</label>
                                    <v-select name="reply_status"
                                        v-model="replyForm.status"
                                        label="text"
                                        :reduce="item => item.id"
                                        :options="statusOptions"
                                        placeholder="Keep current status"
                                    />
                                </div>
                            </div>
                            <p v-else class="text-muted">This complain is closed — no further replies can be sent.</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" v-if="replyComplain && replyComplain.status !== 5" @click.prevent="submitReply">Send Reply</button>
                            <button type="button" class="btn btn-danger" @click="cancelModal">Cancel</button>
                        </div>
                    </b-overlay>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import config from '@/config'
import CopyId from '../../components/global/CopyId.vue'
import { createPopper } from '@popperjs/core'
export default {
    name: 'Complain',
    components: {
        CopyId
    },
    data () {
        return {
            loader: false,
            errors: {},
            createModal: false,
            assignModal: false,
            assignForm: null,
            historyModal: false,
            historyLoader: false,
            historyComplain: null,
            historyList: [],
            replyModal: false,
            replyLoader: false,
            replyComplain: null,
            replyList: [],
            replyForm: { body: '', status: null },
            statusOptions: [
                { id: 1, text: 'Open' },
                { id: 2, text: 'Assigned' },
                { id: 3, text: 'In Progress' },
                { id: 4, text: 'Resolved' },
                { id: 5, text: 'Closed' },
            ],
            filter: {
                code: '',
                order_id: '',
                merchant_id: '',
                assigned_user_id: null,
                status: '',
            },
            form: {
                title: '',
                description: '',
                order_id: '',
                assigned_role_id: null,
                assigned_user_id: null,
            },
            imageFile: null,
            pagination: {
                currentPage: 1,
                totalRows: 0,
                perPage: this.$store.state.commonObj.perPage,
                slOffset: 1
            }
        }
    },
    created () {
        this.loadData()
    },
    watch: {
        stateReload: function (newVal, oldVal) {
            if (newVal != oldVal) {
                this.loadData()
            }
        }
    },
    computed: {
        stateReload () {
            return this.$store.state.stateReload
        },
        listData () {
            return this.$store.state.list
        },
        commonObj () {
            return this.$store.state.commonObj
        },
        roleList () {
            return this.commonObj.roleList
        },
        imagePath () {
            return this.$image_path
        }
    },
    methods: {
        reload () {
            this.filter = Object.assign({}, {
                code: '',
                order_id: '',
                merchant_id: '',
                assigned_user_id: null,
                status: '',
            })
            this.searchData()
        },
        // Lets the status v-select escape the table's overflow clipping (append-to-body needs manual positioning).
        dropdownPosition (dropdownList, component, { width }) {
            dropdownList.style.width = width
            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: 'bottom',
                modifiers: [{ name: 'offset', options: { offset: [0, 0] } }],
            })
            return () => popper.destroy()
        },
        searchData () {
            this.pagination.currentPage = 1
            this.loadData()
        },
        async loadData () {
            this.loader = true
            const params = {
                page: this.pagination.currentPage,
                per_page: this.pagination.perPage,
                code: this.filter.code || undefined,
                order_id: this.filter.order_id || undefined,
                merchant_id: this.filter.merchant_id || undefined,
                assigned_user_id: this.filter.assigned_user_id || undefined,
                status: this.filter.status || undefined,
            }
            const response = await config.getData('/complain', params)
            this.loader = false
            if (response.status == 200) {
                this.$store.dispatch('setList', response.data.data)
                this.paginationData(response.data)
            } else {
                this.$store.dispatch('setList', [])
            }
        },
        paginationData (data) {
            this.pagination.currentPage = data.current_page
            this.pagination.totalRows = data.total
            this.pagination.perPage = data.per_page
            this.pagination.slOffset = this.pagination.perPage * this.pagination.currentPage - this.pagination.perPage + 1
        },
        roleWiseUserList (roleId) {
            return this.commonObj.userList.filter(u => u.role_id == roleId)
        },
        raisedByLabel (complain) {
            if (complain.type == 2 && complain.merchant) {
                return complain.merchant.business || complain.merchant.name
            }
            if (complain.type == 1 && complain.user) {
                return complain.user.name
            }
            return '-'
        },
        statusLabel (status) {
            const found = this.statusOptions.find(s => s.id == status)
            return found ? found.text : status
        },
        onFileChange (e) {
            this.imageFile = e.target.files[0] || null
        },
        showCreateModal () {
            this.createModal = true
        },
        cancelModal () {
            this.createModal = false
            this.assignModal = false
            this.assignForm = null
            this.historyModal = false
            this.historyComplain = null
            this.replyModal = false
            this.replyComplain = null
            this.replyForm = { body: '', status: null }
            this.errors = {}
        },
        async createComplain () {
            this.loader = true
            this.$store.dispatch('stateReload', true)

            const formData = new FormData()
            formData.append('title', this.form.title)
            formData.append('description', this.form.description)
            if (this.form.order_id) formData.append('order_id', this.form.order_id)
            if (this.form.assigned_role_id) formData.append('assigned_role_id', this.form.assigned_role_id)
            if (this.form.assigned_user_id) formData.append('assigned_user_id', this.form.assigned_user_id)
            if (this.imageFile) formData.append('image', this.imageFile)

            const response = await config.postData('/complain/store', formData)
            this.loader = false
            if (response.status == 201) {
                this.createModal = false
                this.form = { title: '', description: '', order_id: '', assigned_role_id: null, assigned_user_id: null }
                this.imageFile = null
                this.$toast.success({ title: 'Success', message: 'Complain created successfully', color: '#218838' })
            } else {
                this.errors = response.errors || {}
                this.$toast.error({ title: 'Error', message: 'Sorry, something went wrong' })
            }
            this.$store.dispatch('stateReload', false)
        },
        openAssignModal (complain) {
            this.assignForm = {
                id: complain.id,
                title: complain.title,
                assigned_role_id: complain.assigned_role_id,
                assigned_user_id: complain.assigned_user_id,
            }
            this.assignModal = true
        },
        async submitAssign () {
            this.loader = true
            this.$store.dispatch('stateReload', true)
            const response = await config.postData(`/complain/assign/${this.assignForm.id}`, {
                assigned_role_id: this.assignForm.assigned_role_id,
                assigned_user_id: this.assignForm.assigned_user_id,
            })
            this.loader = false
            if (response.status == 200) {
                this.assignModal = false
                this.assignForm = null
                this.$toast.success({ title: 'Success', message: 'Complain assigned successfully', color: '#218838' })
            } else {
                this.errors = response.errors || {}
                this.$toast.error({ title: 'Error', message: 'Sorry, something went wrong' })
            }
            this.$store.dispatch('stateReload', false)
        },
        async openHistoryModal (complain) {
            this.historyComplain = complain
            this.historyModal = true
            this.historyLoader = true
            this.historyList = []
            const response = await config.getData(`/complain/history/${complain.id}`)
            this.historyLoader = false
            if (response.status == 200) {
                this.historyList = response.data
            }
        },
        async openReplyModal (complain) {
            this.replyComplain = complain
            this.replyForm = { body: '', status: null }
            this.replyModal = true
            this.replyLoader = true
            this.replyList = []
            const response = await config.getData(`/complain/replies/${complain.id}`)
            this.replyLoader = false
            if (response.status == 200) {
                this.replyList = response.data
            }
        },
        async submitReply () {
            if (!this.replyForm.body || !this.replyForm.body.trim()) {
                this.errors = { body: ['Reply text is required'] }
                return
            }
            this.replyLoader = true
            const payload = { body: this.replyForm.body }
            if (this.replyForm.status) payload.status = this.replyForm.status

            const response = await config.postData(`/complain/reply/${this.replyComplain.id}`, payload)
            this.replyLoader = false
            if (response.status == 201) {
                this.$toast.success({ title: 'Success', message: 'Reply sent', color: '#218838' })
                this.cancelModal()
                this.loadData()
            } else {
                this.errors = response.errors || {}
                this.$toast.error({ title: 'Error', message: response.message || 'Sorry, something went wrong' })
            }
        },
        async updateStatus (complain, status) {
            this.loader = true
            const response = await config.postData(`/complain/status-update/${complain.id}`, { status })
            this.loader = false
            if (response.status == 200) {
                this.$toast.success({ title: 'Success', message: 'Status updated', color: '#218838' })
                this.loadData()
            } else {
                this.$toast.error({ title: 'Error', message: 'Sorry, something went wrong' })
            }
        }
    }
}
</script>
<style scoped>
.reply-thread {
    max-height: 260px;
    overflow-y: auto;
}
.reply-item {
    border-bottom: 1px solid #eee;
    padding: 8px 0;
}
.reply-item:last-child {
    border-bottom: none;
}
</style>
